<template>
  <div id="app-root">
    <!-- Search -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
      mode="out-in"
    >
      <SearchBar v-if="showSearch" />
    </transition>

    <!-- Header -->
    <MainHeader />

    <!-- Page -->
    <RouterView v-slot="{ Component, route }">
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster"
        mode="out-in"
      >
        <component :is="Component" :key="route.path" />
      </transition>
    </RouterView>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { RouterView, useRouter, useRoute } from "vue-router";
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import MainHeader from "./components/MainHeader.vue";
import SearchBar from "./components/SearchBar/SearchBar.vue";

import { showSearch } from "./services/helpers";
import { usePreferencesStore } from "./stores";

const router = useRouter();
const route = useRoute();
const preferencesStore = usePreferencesStore();
const { locale } = useI18n({ useScope: "global" });


/**
 * Canonical URL (reaktiv, SSR-safe)
 */
const canonicalUrl = computed(() => {
  return "https://sachsenkabel.de" + route.path;
});

/**
 * Head-Definition (SSR + Client, deklarativ)
 */
useHead(() => ({
  htmlAttrs: {
    lang: preferencesStore.language,
  },

  meta: [
    {
      name: "google-site-verification",
      content: "Gybx0OhOBwvTjD9Q9Y0jE2Fb5QJf6zKlyGy2YbtCepg",
    },
  ],

  link: [
    {
      rel: "canonical",
      href: canonicalUrl.value,
    },
  ],

  script: [
    /**
     * Cookiebot – immer laden
     */
    {
      src: "https://consent.cookiebot.com/uc.js",
      defer: true,
      "data-cbid": "9d3a31c7-ad6e-4c91-ba56-4abe0a7dbb0c",
      "data-blockingmode": "auto",
      type: "text/javascript",
    },

    // GTM: von Cookiebot gesteuert
    {
      type: "text/plain",
      "data-cookieconsent": "marketing",
      children: `
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),
              dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-M55TJQVS');
      `,
    },
  ],
}));

onMounted(async () => {
  await router.isReady();
  preferencesStore.updateGivenLanguages();
  preferencesStore.updateButtonTypes();
 
});

</script>
